// AUTO-GENERATED by scripts/write-build-version.ts — do not edit.
// Empty string = version key disabled (current/pre-deploy-skew behaviour).
export const BUILD_VERSION = "0a636f26923434e61c00e474d6e9723e";
// The git sha, ALWAYS — BUILD_VERSION is a render-identity hash under
// CACHE_NAMESPACE_PIN=1 and cannot be compared against a commit.
export const BUILD_COMMIT = "2f21e499ef58";
